export const enumSearchQuoiLabel = {
    COMPETENCE : "competencesLabel",
    APPELLATION : "appellationsLabel",
    DIPLOME : "diplomesLabel",
    FORMATION : "formationsLabel"
}